export const RegistrationStatus = {
	BEFORE: 'before',
	OPEN: 'open',
	AFTER: 'after',
}
